module.exports = __webpack_public_path__ + "static/img/logo@2x.59aa236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo@2x.png
// module id = O9CT
// module chunks = 1